// universidades.js
//
// Universidades chilenas con escuela de medicina, para «Dónde estudias / estudiaste» y «Universidad
// de tu beca» del alta (#1738, R14). Es una AYUDA para escribir, no una validación: quien no
// aparece escribe la suya y se guarda tal cual (hasta 200 caracteres), igual que la especialidad.
// Lo usa `CampoConLista` (el mismo input con lista de la especialidad). Cubre R14 —
// .claude/specs/1738-etapa-alta/

export const UNIVERSIDADES = [
  "Pontificia Universidad Católica de Chile",
  "Universidad Andrés Bello",
  "Universidad Arturo Prat",
  "Universidad Austral de Chile",
  "Universidad Autónoma de Chile",
  "Universidad Bernardo O'Higgins",
  "Universidad Católica de la Santísima Concepción",
  "Universidad Católica de Temuco",
  "Universidad Católica del Maule",
  "Universidad Católica del Norte",
  "Universidad Central de Chile",
  "Universidad de Aconcagua",
  "Universidad de Antofagasta",
  "Universidad de Atacama",
  "Universidad de Chile",
  "Universidad de Concepción",
  "Universidad de La Frontera",
  "Universidad de las Américas",
  "Universidad de los Andes",
  "Universidad de Magallanes",
  "Universidad de O'Higgins",
  "Universidad de Playa Ancha",
  "Universidad de Santiago de Chile",
  "Universidad de Talca",
  "Universidad de Tarapacá",
  "Universidad de Valparaíso",
  "Universidad del Alba",
  "Universidad del Desarrollo",
  "Universidad Diego Portales",
  "Universidad Finis Terrae",
  "Universidad Mayor",
  "Universidad San Sebastián",
  "Universidad Santo Tomás",
  "Universidad Viña del Mar",
];
